/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import IconComponent from '../../../../Icon';

import { IOptionsProps } from './_props';

import useInputOptionsTheme from './themes';

/**
 * Options Component
 */

function Options({
  open,
  options,
  valueText,
  iconPosition,
  highlightOptions,
  getItemProps,
  hoveredItemIndex,
  selectedItem,
}: Omit<IOptionsProps, 'getMenuProps'>) {
  const {
    optionsWrapperThemeClasses,
    optionThemeClasses,
    optionActiveThemeClasses,
    optionSelectedThemeClasses,
    optionIconThemeClasses,
    optionHighlightedTextThemeClasses,
  } = useInputOptionsTheme();

  if (!open) return null;
  if (!options.length) return null;

  const highlightIndexes =
    highlightOptions && valueText
      ? options.map((opt) => opt.label.toLowerCase().indexOf(valueText.toLowerCase()))
      : [];

  return (
    <div className={optionsWrapperThemeClasses}>
      {options.map((option, index) => (
        <li
          data-testid={`option-${option.value}`}
          key={option.value}
          className={twMerge(
            optionThemeClasses,
            hoveredItemIndex === index && optionActiveThemeClasses,
            selectedItem?.value === option.value && optionSelectedThemeClasses,
            {
              'flex-row-reverse': iconPosition === 'right',
            },
          )}
          {...getItemProps({ item: option, index })}
        >
          <IconComponent iconName={option.icon} size="IconS" className={optionIconThemeClasses} />

          <span className="flex-1">
            {highlightOptions && valueText && highlightIndexes[index] >= 0 ? (
              <>
                {option.label.substring(0, highlightIndexes[index])}

                <span className={optionHighlightedTextThemeClasses}>
                  {option.label.substring(highlightIndexes[index], highlightIndexes[index] + valueText.length)}
                </span>

                {option.label.substring(valueText.length + highlightIndexes[index])}
              </>
            ) : (
              option.label
            )}
          </span>
        </li>
      ))}
    </div>
  );
}

function OptionsWrapper({ getMenuProps, ...optionsProps }: IOptionsProps) {
  return (
    <ul {...getMenuProps()}>
      <Options {...optionsProps} />
    </ul>
  );
}

export default OptionsWrapper;
